//let DbFunctions = require('./dbfunctions').DbFunctions
let okeResponse = require('okeoke.standardresponse')
let { UUID } = require("uuidjs")
import { storeExternalPayment, getUnsyncedExternalPayments } from '../IDB/db'
import ordereduuid from '../Helpers/timeuuid'

let ExternalPayments = function (clientSocket, client, orders) {
  const uid = UUID.generate()
  let payments = {}

  function transcodePaymentItems(items, delivery, storno = false) {
    let _orders = {}
    for (let item of items) {
      let amt = (storno ? -item.amt : +item.amt)
      let cnt = (storno ? -item.cnt : +item.cnt)
      _orders[item.oid] = _orders[item.oid] || { items: {}, amount: 0 }
      _orders[item.oid].items = {
        ..._orders[item.oid].items,
        [item.iid]: { amt, cnt }
      }
      _orders[item.oid].amount += amt
    }

    for (let [orderUUID, deliveryPayment] of Object.entries(delivery)) {
      _orders[orderUUID] = _orders[orderUUID] || { items: {}, amount: 0 }
      _orders[orderUUID].delivery = (storno ? -deliveryPayment : +deliveryPayment)
      _orders[orderUUID].amount += (storno ? -deliveryPayment : +deliveryPayment)
    }
    return _orders
  }

  async function getPaymentFromServer(uuid) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit(
          'getExternalPayment',
          {
            uuid
          },
          (e) => {
            //console.log('getExternalPayment - ONLINE', e)
            resolve(e)
          }
        )
      }
    })
  }

  async function getPayment(uuid) {
    let payment = payments[uuid]
    if (payment != null) {
      return okeResponse(true, 200, 'OK', payment)
    } else {
      let payment = await getPaymentFromServer(uuid)
      if (payment.success) {
        payments[uuid] = payment.data
        return okeResponse(true, 200, 'OK', payment.data)
      } else {
        return okeResponse(false, 404, 'Not found', null)
      }
    }
  }

  async function syncPayment(payment) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        payment.syncneeded = 1
        storeExternalPayment(payment)
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        let done = false
        setTimeout(() => {
          if(!done) payment.syncneeded = 1
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit(
          'syncExternalPayment',
          {
            payment
          },
          (e) => {
            //console.log('syncExternalPayment - ONLINE', e)
            done = true
            if(!e.success) {
              payment.syncneeded = 1
              storeExternalPayment(payment)
            } else {
              e.data.syncneeded = 0
              storeExternalPayment(e.data)
            }
            resolve(e)
          }
        )
      }
    })
  }

  async function addPaymentStatus(paymentUUID, status) {
    let payment = await getPayment(paymentUUID)
    if(!payment.success) return payment
    status.uuid = ordereduuid()
    if(payments[paymentUUID].statuses == null) {
      payments[paymentUUID].statuses = [{ ...status }]
    } else {
      payments[paymentUUID].statuses.push({ ...status })
    }
    syncPayment(payments[paymentUUID])
    return okeResponse(true, 201, 'Inserted', { status })
  }

  async function setPayment(payment) {
    payment.uuid = ordereduuid()
    payment.insertTimestamp = new Date().getTime()
    payment.sysUserUUID = client.localUser?.userUUID || null
    payment.deviceUUID = client.tokenData?.deviceUUID || null
    let { items, stornoPaymentUUID = null, agentType = "", agentSubType = null, agentID = 0, extTransactionID = '', delivery } = payment
    if (stornoPaymentUUID != null) {
      let originalPayment = await getPayment(stornoPaymentUUID)
      if (!originalPayment.success) return okeResponse(false, 404, 'Original payment not found', null)
      let _orders = transcodePaymentItems(originalPayment.data?.items, originalPayment.data?.delivery, true)
      for await (let [orderUUID, orderData] of Object.entries(_orders)) {
        let order = await orders.loadOrder(orderUUID)
        if (order != null) {
          order.externalPayments.set({
            uuid: payment.uuid,
            stornoPaymentUUID,
            extTransactionID,
            insertTimestamp: payment.insertTimestamp,
            items: orderData.items,
            delivery: orderData.delivery,
            amount: orderData.amount,
            sysUserUUID: payment.sysUserUUID,
            deviceUUID: payment.deviceUUID,
            agentType,
            agentSubType,
            agentID
          })
        }
      }
    } else {
      let _orders = transcodePaymentItems(items, delivery)
      for await (let [orderUUID, orderData] of Object.entries(_orders)) {
        let order = await orders.loadOrder(orderUUID)
        if (order != null) {
          //console.log({order})
          let paidItemIIDs = {}
          // Check order items, slice orderItem if needed for payment
          for(let [iid, item] of Object.entries(orderData.items)) {
            paidItemIIDs[iid] = true
            //console.log({item, assembledOrderItems: order.assembledOrderItems})
            let originalCount = order.assembledOrderItems?.[iid]?.count
            //console.log({originalCount, cnt: item.cnt})
            if(item.cnt > 0 && originalCount > item.cnt) {
              order.items.sliceItem(iid, originalCount - item.cnt)
            }
          }
          order.externalPayments.set({
            uuid: payment.uuid,
            extTransactionID,
            insertTimestamp: payment.insertTimestamp,
            items: orderData.items,
            delivery: orderData.delivery,
            amount: orderData.amount,
            sysUserUUID: payment.sysUserUUID,
            deviceUUID: payment.deviceUUID,
            agentType,
            agentSubType,
            agentID
          })
        }
      }
    }
    payment.summary = concatenatePaymentOrders(payment)
    payments[payment.uuid] = payment
    let syncRes = await syncPayment(payment)
    if(syncRes.success) {
      payment.shortID = syncRes.data?.shortID || null
      payments[payment.uuid] = payment
    }
    return okeResponse(true, 201, 'Inserted', { payment })
  }

  async function syncOffline() {
    let unsyncedPayments = await getUnsyncedExternalPayments()
    for (let payment of unsyncedPayments) {
      syncPayment(payment)
    }
  }

  function onConnectionChange(data) {
    switch (data.state) {
      case 'Authorized':
        syncOffline()
        break
      default:
        break
    }
  }

  function init() {
    clientSocket.addCallback('onConnectionChange', uid, onConnectionChange)
  }

  const findSize = (sizes, sizeUUID) => {
    for (let size of sizes) {
      if (size.uuid === sizeUUID) return {
        name: size.name,
        unit: size.unit,
        unitType: size.unitType
      }
    }
    return {
      unitType: 'piece',
      unit: '1.00'
    }
  }

  function concatenatePaymentOrders (payment) {
    let items = []
    let sums = {
      tippAmount: +(payment.tippAmount || 0),
      deliveryCost: 0,
      totalPrice: +(payment.tippAmount || 0),
      discountPrice: +(payment.tippAmount || 0),
      discountAmount: 0,
      sumServiceFee: 0,
      sumDiscountServiceFee: 0,
    }
    for (let deliveryCost of Object.values(payment.delivery)) {
      sums.deliveryCost += +deliveryCost
      sums.totalPrice += +deliveryCost
      sums.discountPrice += +deliveryCost
    }
    for (let item of payment.items) {
      if(item.cnt > 0) {
        let oItem = orders.orders?.[item.oid]?.assembledOrderItems?.[item.iid]
        let takeAway = orders.orders?.[item.oid]?.order?.takeAway || false
        let assembledItem = {
          count: item.cnt,
          quantity: oItem.quantity,
          quantityBase: oItem.quantityBase,
          size: findSize(oItem.sizes, oItem?.selectedSizeUUID),
          itemName: `${oItem?.name?.hu || 'NA'}${((oItem?.takeAway == null ? takeAway : oItem.takeAway) ? ' (TA)' : '')}`,
          sizeName: `${oItem?.sizeName?.hu || ''}`,
          unitType: oItem.unitType,
          basePriceUnit: oItem.basePriceUnit,
          modifierGroups: oItem.modifierGroups,
          sumPriceUnit: oItem.sumPriceUnit,
          sumPrice: oItem.sumPriceUnit * item.cnt,
          sumDiscountPriceUnit: item.itm / item.cnt,
          sumDiscountPrice: item.itm,
          vat: oItem.vat,
          serviceFee: +item.ser || 0,
          serviceFeeNoDiscount: (+oItem.serviceFeeUnitNoDiscount || 0) * item.cnt,
          serviceFeePercent: oItem.serviceFeePercent || 0,
          packageName: oItem.package?.name?.hu || 'Csomagolás',
          packagePrice: oItem.packagePrice,
          sumPackagePrice: oItem.packagePrice * item.cnt,
          packageDiscountPrice: oItem.packageDiscountPrice,
          sumPackageDiscountPrice: oItem.packageDiscountPrice * item.cnt,
          depositPrice: oItem.depositPrice,
          depositVat: oItem.depositVat,
          notes: oItem.notes
        }
        sums.totalPrice += +(assembledItem.sumPrice + assembledItem.sumPackagePrice + (+assembledItem.serviceFeeNoDiscount || 0))
        sums.discountPrice += +(assembledItem.sumDiscountPrice + assembledItem.sumPackageDiscountPrice + (+assembledItem.serviceFee || 0))
        sums.sumServiceFee += +assembledItem.serviceFeeNoDiscount || 0
        sums.sumDiscountServiceFee += +assembledItem.serviceFee || 0
        items.push(assembledItem)
      }
    }
    sums.discountAmount += (+sums.totalPrice - +sums.discountPrice)
    //console.log({sums})
    return { items, sums }
  }

  async function finalizeExternalVipPurchase(vipID, authUUID) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 10000)
        clientSocket.ioclient.emit(
          'finalizeExternalVipPurchase',
          {
            vipID, 
            authUUID
          },
          (e) => {
            //console.log('finalizeExternalVipPurchase', e)
            resolve(e)
          }
        )
      }
    })
  }

  return {
    setPayment,
    getPayment,
    init,
    addPaymentStatus,
    concatenatePaymentOrders,
    finalizeExternalVipPurchase
  }
}

export { ExternalPayments }